<template>
	<modal
		v-if="!isFetchingAssignPromo"
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span>{{ $t('Assign Coupon') }}</span>
		</template>
		<template slot="body">
			<div>
				<!-- form add user -->
				<div class="form-group rundown-collab mt-2 mb-2">
					<label class="typo__label">Users</label>
					<div>
						<multiselect class="rundown-collab-input" v-model="userIds" tag-placeholder="Add User"
						placeholder="Search or select a user" label="name" track-by="id"
						:options="users"  :multiple="true" :searchable="true" :show-labels="false">
						<template slot="singleLabel" slot-scope="props">
							<span>{{ props.option.name }}</span>
						</template>
						<template slot="option" slot-scope="props">
							<div class="d-flex justify-content-between"><span>{{ props.option.name }}</span><span>{{ props.option.email }}</span></div>
						</template>
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						<span slot="noResult">Oops! No Users found.</span></multiselect>
					</div>
				</div>
				<div class="form-group rundown-collab mt-2 mb-2">
					<label class="typo__label">Code</label>
						<div>
							<multiselect class="rundown-collab-input" v-model="code" tag-placeholder="Add Code"
							placeholder="Search or select a code" label="code" track-by="id"
							:options="promos"  :multiple="false" :searchable="true" :show-labels="false">
							<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
							</span>
							<span slot="noResult">Oops! No Code found.</span></multiselect>
						</div>
				</div>
				<button
					:disabled="userIds && userIds.length === 0 || code && code.length === 0"
					@click="addExisting"
					type="submit"
					class="btn btn-submit btn-primary mt-3 mb-1"
					:class="{ 'is-loading': isSaving }">
					<span>{{ $t('Assign Coupon') }}</span>
				</button>
			</div>
			<hr class="mb-3">
			<!-- list users -->
			<label class="typo__label">List of users having promo</label>
			<div>
				<div class="text-center" v-if="isFetchingPromo">
					<div class="is-loading large"></div>
				</div>
				<div id="styleScroll1" class="list-group list-quotation-wrapper mb-1">
					<div v-for="item in promos" :key="item.id">
						<div @click="openListUsersPromo(item.id)"	>
							<a class="list-group-item text-decoration-none pointer pt-3">
								<div class="d-flex justify-content-between">
									<div class="d-flex"><h5 class="mr-1 text-white">{{item && item.code && item.code ? item.code : ''}}</h5>
									</div>
									<div class="d-flex">
										<div class="text-primary" @click.stop="openListUsersPromo(item.id)">
											Detail
										</div>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div v-if="!isFetchingPromo && promos.length === 0" class="text-center">
						{{ $t('You have not assign any coupon code yet to users') }}
					</div>
				</div>
			</div>
			<!-- modal list per category -->
			<modal
				size="large"
				@close="closeModalList"
				v-if="isModalList"
				:hide-footer="true">
				<template slot="header">
					<label>{{ $t('List of users having promo') }}</label>
				</template>
				<template slot="body">
					<div class="mh-420">
						<table class="table table-striped mb-4">
							<div class="p-5 text-center absolute" v-if="isFetchingModal">
								<div class="is-loading large"></div>
							</div>
							<thead>
								<tr>
									<th width="5%">{{ $t('No') }}</th>
									<th width="20%">{{ $t('Name') }}</th>
									<th width="20%">{{ $t('Email') }}</th>
									<th width="20%">{{ $t('Active/Status') }}</th>
								</tr>
							</thead>
							<div class="p-5 text-center absolute" v-if="isFetching">
								<div class="is-loading large"></div>
							</div>
								<tbody>
									<tr
										v-for="(item, index) in itemsModal"
										:key="item.id">
										<td>{{ index+1 }}</td>
										<td>{{ item && item.user && item.user.name ? item.user.name : '' }}</td>
										<td>{{ item && item.user && item.user.email ? item.user.email : '' }}</td>
										<td v-if="item.is_active">Not Used</td>
										<td v-if="!item.is_active">Used</td>
									</tr>
								</tbody>
							</table>
							<div class="text-center absolute disabled mt-4" v-if="itemsModal.length === 0 && !isFetchingModal">{{$t('No Users available')}}</div>
							<!-- Table Pagination -->
							<pagination
								v-if="isFetchingModal"
								:total-pages="totalPagesModal"
								:current-page="pageModal"
								:last-page="lastPageModal"
								@select="onPageSelectedModal">
							</pagination>
						</div>
				</template>
			</modal>
		</template>
		<!-- Delete Confirmation -->
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import Pagination from '@/components/Pagination.vue';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import assignPromosApi from '@/api/promoCode';
import usersApi from '@/api/user';

export default {
	name: 'ModalAddQuotation',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
		Multiselect,
		Pagination,
	},
	data() {
		return {
			isSaving: false,
			users: [],
			userIds: [],
			isFetching: false,
			isFetchingAssignPromo: false,
			assignPromos: null,
			isConfirm: false,
			isActivateAssigne: false,
			selectedAssignePackage: null,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			isFetchingPromo: false,
			promos: [],
			code: null,
			// modal items
			isModalList: false,
			status: '',
			itemsModal: [],
			lastPageModal: 1,
			totalItemsModal: 0,
			pageModal: 1,
			limitModal: 10,
			isFetchingModal: false,
			promoCodeId: '',
		};
	},
	methods: {
		fetchUser() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.users = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'User',
					text: message,
				});
				this.isFetching = false;
			};
			const paramsUser = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				role: 'client',
			};
			usersApi.getUsers(paramsUser, callback, errorCallback);
		},
		fetchPromo() {
			this.isFetchingPromo = true;
			const callback = (response) => {
				const items = response.data;
				this.promos = items;
				this.isFetchingPromo = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Promos',
					text: message,
				});
				this.isFetchingPromo = false;
			};
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				promo_id: this.data.id,
			};
			assignPromosApi.getList(params, callback, errorCallback);
		},
		addTag() {
			this.users.push();
			this.userIds.push();
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			assignPromosApi.assignPromo(params, callback, errorCallback);
		},
		addExisting() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			assignPromosApi.assignPromo(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
		},
		openListUsersPromo(promoCodeId) {
			this.isModalList = true;
			this.promoCodeId = promoCodeId;
			this.fetchModal();
		},
		fetchModal(reset = false, pageModal) {
			this.isFetchingModal = true;
			if (reset) {
				this.pageModal = 1;
				this.itemsModal = [];
			}
			if (pageModal) this.pageModal = pageModal;
			const params = {
				page: pageModal,
				limit: 10,
				order_by: 'id',
				sort_by: 'asc',
				promo_code_id: this.promoCodeId,
			};
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limitModal) this.isAll = true;
				this.itemsModal = items;
				this.totalItemsModal = response.total;
				this.lastPageModal = response.lastPage;
				this.isFetchingModal = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetchingModal = false;
			};
			assignPromosApi.getListPromoUser(params, callback, errorCallback);
		},
		closeModalList() {
			this.isModalList = false;
			this.status = '';
			this.itemsModal = [];
			this.totalItemsModal = 0;
			this.lastPageModal = 1;
			this.pageModal = 1;
		},
		// confirmRemoveItem(item) {
		// 	this.selectedAssignePackage = item;
		// 	this.isConfirmRemoveVisible = true;
		// },
		// removeItem(item) {
		// 	this.isRemoving = true;
		// 	const callback = (response) => {
		// 		const index = this.assignPromos.findIndex(({ id }) => id === item.id);
		// 		if (index !== -1) {
		// 			this.assignPromos.splice(index, 1);
		// 		}
		// 		this.isRemoving = false;
		// 		this.isConfirmRemoveVisible = false;
		// 		this.$notify({
		// 			group: 'app',
		// 			type: 'success',
		// 			title: 'Remove Promos',
		// 			text: response.message,
		// 		});
		// 	};
		// 	const errorCallback = () => {
		// 		this.isRemoving = false;
		// 		this.$notify({
		// 			group: 'app',
		// 			type: 'error',
		// 			title: 'Remove Promos',
		// 			text: 'Failed delete user',
		// 		});
		// 	};
		// 	assignPromosApi.delete(item.id, callback, errorCallback);
		// },
		reset() {
			this.userIds = '';
		},
		onPageSelectedModal(pageModal) {
			this.fetchModal(true, pageModal, this.promoCodeId);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		params() {
			const users = [];
			for (let index = 0; index < this.userIds.length; index++) {
				const id = this.userIds[index].id;
				users.push(id);
			}
			// const access = this.access;
			const params = {
				code: this.code.code,
				user_ids: JSON.stringify(users),
			};
			return params;
		},
		filteredAssignPromo() {
			const filtered = this.promos.filter(item => item.is_archived);
			return filtered;
		},
		totalPagesModal() {
			const total = Math.ceil(this.totalItemsModal / this.limitModal);
			return total;
		},
	},
	created() {
		this.fetchUser();
		this.fetchPromo();
		this.initData();
	},
};
</script>
